export const __CustomPageLang = {
    author: 'نویسنده',
    publishedAt: 'منتشر شده در',
    share: 'اشتراک گذاری',
    related: 'مطالب مشابه',
    seeAll: 'مشاهده همه',
    tehrantoBlog: 'بلاگ تهرانتو',
};
